import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../users/user.service';
import { environment } from '../../../environments/environment';
import { GetUrlParameters } from '../../utils/getUrlParameters';
import { throwError as observableThrowError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class LiveChatService {

  private urlParamsUserPolling = environment.urlParamsUserPolling;
  private urlParamsNegotiate = environment.urlParamsNegotiate;

  constructor(private http: HttpClient) { }

  postUserChat = function(text, sessionId, firstMessage?){

    let requestParams: any;

    requestParams = { 
      text : text,
      sessionId: sessionId,
      firstMessage:firstMessage
    }

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': this.ariaToken,
      'Ocp-Apim-Subscription-Key': environment.apikey
    });

    this.requestOptions = {
      headers: headers
    };

    return this.http
    .post(this.urlParamsUserPolling, requestParams, this.requestOptions)
    
  }

  getUserChatInfo = function(sessionId){

    let requestParams: any;

    requestParams = { 
      sessionId : sessionId
    }

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': this.ariaToken,
      'Ocp-Apim-Subscription-Key': environment.apikey
    });

    this.requestOptions = {
      headers: headers
    };

    return this.http
    .get(this.urlParamsUserPolling,{params : requestParams, headers : headers })
    .pipe(catchError(this.handleErrorObservable));

  }

  negotiate = function(userId){

    let requestParams: any;

    requestParams = { 
      userid : userId
    }

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': this.ariaToken,
      'Ocp-Apim-Subscription-Key': environment.apikey
    });

    this.requestOptions = {
      headers: headers
    };

    return this.http
    .get(this.urlParamsNegotiate,{params : requestParams, headers : headers, responseType :'text' }).pipe(
      map(this.handleAIResponse),
      catchError(this.handleErrorObservable));
  }

    // handle backend errors
    private handleErrorObservable(errorResponse: HttpErrorResponse | any) {
      return observableThrowError(errorResponse.error || errorResponse.message || errorResponse);
    }

      // handle backend response
  private handleAIResponse = (apiResponse: HttpErrorResponse | any) => {

    return apiResponse;
  }

}
